import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from 'auth/hooks/useAuth';
import {
  BadgeIconContainer,
  MenuContainer,
  UserMenuContainer,
} from './ActionsMenu.styles';
import { CHANGE_PASSWORD_PATH } from 'user/routes';
import { AppMenu } from '../Menu/AppMenu/AppMenu';
import { AppMenuContentProps } from '../Menu/models/MenuContentProps';
import { Icon } from '@orbita-ui/core';
import { HeaderButton } from '../AppHeader/AppHeader.styles';
import { useComponentVisible } from 'shared/hooks/useComponentVisible';
import { LogoutButton } from './LogoutButton';

export const ACTIONS_MENU_ITEMS: AppMenuContentProps[] = [
  // {
  //   itemType: 'menuItem',
  //   path: '/mail',
  //   text: 'Mail',
  //   selected: false,
  //   iconName: 'MailIcon',
  // },
  {
    itemType: 'menuItem',
    path: CHANGE_PASSWORD_PATH,
    text: 'Cambiar contraseña',
    selected: false,
    iconName: 'KeyIcon',
  },
  // {
  //   itemType: 'menuItem',
  //   path: '/faq',
  //   text: 'Preguntas frecuentes',
  //   selected: false,
  //   iconName: 'HelpIcon',
  // },
  // {
  //   itemType: 'menuItem',
  //   path: '/search',
  //   text: 'Buscar',
  //   selected: false,
  //   iconName: 'SearchIcon',
  // },
];

function formatName(name: string): string {
  if (!name) {
    return '';
  }
  return name
    .toLowerCase()
    .split('_')
    .map((part) => part[0].toUpperCase() + part.slice(1))
    .join(' ');
}

export function ActionsMenu() {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { user } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    setIsComponentVisible(false);
  }, [pathname, setIsComponentVisible]);

  return (
    <>
      <UserMenuContainer ref={ref}>
        <HeaderButton onClick={() => setIsComponentVisible((isVisible) => !isVisible)}>
          <BadgeIconContainer>
            <Icon name="UserIcon" />
          </BadgeIconContainer>
          <div>
            <p className="username">{user.username}</p>
            <p className="roleuser">{formatName(user?.tipoUsuario)}</p>
          </div>
          <Icon
            name={isComponentVisible ? 'ChevronUpSmallIcon' : 'ChevronDownSmallIcon'}
          />
        </HeaderButton>
        <MenuContainer
          style={{
            display: isComponentVisible ? 'block' : 'none',
          }}
        >
          <AppMenu menu={ACTIONS_MENU_ITEMS} />
        </MenuContainer>
      </UserMenuContainer>
      <LogoutButton />
    </>
  );
}
